'use strict';

/* eslint no-undef: "off" */
/**
 * XPark flash sale
 */
define('xparkFlashSale',['xparkHomepageApi', 'svgIcon', 'util', 'appStorage', 'addToWishlistApi', 'deleteWishlistApi', 'addToCartApi', 'busEvent', 'selectSpecModal', 'serialize', 'GAReport'], function (xparkHomepageApi, svgIcon, Util, appStorage, addToWishlistApi, deleteWishlistApi, addToCartApi, busEvent, selectSpecModal, GAReport) {
  return {
    template: '\n      <section class="xp-flash-sale" v-if="products.length || loading">\n        <div v-if="loading" class="skeleton-loading"></div>\n        <div class="xp-flash-sale-panel" v-if="products.length">\n          <img :src="require.toUrl(\'images/pre_launch_bg.png\')" class="xp-flash-sale-bg" />\n          <h2 v-text="info.name"></h2>\n\n          <div class="xp-flash-sale-list">\n            <a\n              v-for="item in products"\n              :key="item.product_id || item.id || item.item_id || item.sku || item.name"\n              class="xp-flash-sale-card"\n              :href="getProductUrl(item)"\n              :aria-label="getProductTitle(item)"\n              @click="handleGA(item)"\n            >\n              <span class="xp-flash-sale-media">\n                <img :src="getProductImage(item)" :alt="getProductTitle(item)" />\n              </span>\n\n              <span class="xp-flash-sale-info">\n                <span class="xp-flash-countdown">\n                  <strong>Countdown</strong>\n                  <span class="xp-flash-time">\n                    <b v-text="item.countdown[0]"></b>\n                    <i></i>\n                    <b v-text="item.countdown[1]"></b>\n                    <i></i>\n                    <b class="is-last" v-text="item.countdown[2]"></b>\n                  </span>\n                </span>\n\n                <span class="xp-flash-copy">\n                  <strong v-text="getProductTitle(item)"></strong>\n                  <span v-text="item.slogan || item.short_description || \'\'"></span>\n                </span>\n\n                <span class="xp-flash-bottom">\n                  <span class="xp-flash-prices">\n                    <span class="xp-flash-price">\n                      <strong v-html="item.final_price_label"></strong>\n                    </span>\n                    <span v-if="item.showOldPrice" class="xp-flash-old-price">\n                      <del v-html="item.max_price_label"></del>\n                    </span>\n                  </span>\n\n                  <span class="xp-flash-actions">\n                    <button\n                      type="button"\n                      class="xp-flash-fav"\n                      :class="{\'is-active\': item.is_in_wishlist}"\n                      @click.stop.prevent="toggleWishlist(item)"\n                    >\n                      <svg-icon\n                        :type="item.is_in_wishlist ? \'wishlistFilled\' : \'wishlist\'"\n                        :color="item.is_in_wishlist ? \'#E50909\' : \'#FE3116\'"\n                        width="22"\n                        height="22"\n                      ></svg-icon>\n                    </button>\n                    <button\n                      type="button"\n                      class="xp-flash-cart"\n                      @click.stop.prevent="handleCartClick(item)"\n                    >\n                      <svg-icon type="cart" width="18" height="18" color="#111111"></svg-icon>\n                    </button>\n                  </span>\n                </span>\n              </span>\n            </a>\n          </div>\n        </div>\n\n        <select-spec-modal\n          v-if="plpProductInfo.product_id"\n          :key="plpProductInfo.product_id"\n          :productInfo="plpProductInfo"\n          :use-global-success-modal="true"\n        ></select-spec-modal>\n      </section>\n    ',
    data: function data() {
      return {
        products: [],
        info: {},
        countdownTimer: null,
        plpProductInfo: {},
        loading: true
      };
    },

    components: {
      svgIcon: svgIcon,
      selectSpecModal: selectSpecModal
    },
    mounted: function mounted() {
      this.fetchFlashSaleProducts();
    },
    beforeDestroy: function beforeDestroy() {
      this.stopCountdownTimer();
    },

    methods: {
      fetchFlashSaleProducts: function fetchFlashSaleProducts() {
        var _this = this;

        this.loading = true;
        xparkHomepageApi.getFlashSales({
          page: 1,
          pageSize: 10
        }).then(function (data) {
          var products = data && data.items;
          var info = data && data.info;

          _this.info = info;

          if (!Array.isArray(products) || !products.length) {
            _this.products = [];
            _this.stopCountdownTimer();
            return;
          }

          _this.products = products.map(function (item) {
            return _this.normalizeProduct(item);
          });
          _this.startCountdownTimer();
        }).catch(function () {}).finally(function () {
          return _this.loading = false;
        });
      },
      normalizeProduct: function normalizeProduct(item) {
        var block = item.block || {};
        var currentPriceLabel = block.price_label || item.final_price_label || '';
        var currentPriceValue = block.price || item.final_price;
        var oldPriceValue = item.max_price;
        var currentPriceNumber = this.parsePriceNumber(currentPriceValue);
        var oldPriceNumber = this.parsePriceNumber(oldPriceValue);

        return Object.assign({}, item, {
          product_id: item.product_id || item.id || item.item_id || '',
          product_type: item.product_type || item.type || (Array.isArray(item.configattr) && item.configattr.length ? 'configurable' : 'simple'),
          final_price: currentPriceValue || item.final_price || '',
          final_price_label: currentPriceLabel || item.final_price_label || '',
          showOldPrice: oldPriceNumber > 0 && oldPriceNumber > currentPriceNumber,
          countdownEnd: this.getCountdownEnd(block.end_date),
          countdown: this.getCountdownParts(block.end_date),
          is_in_wishlist: Boolean(item.is_in_wishlist || item.in_wishlist || item.is_favorite),
          wishlist_item_id: item.wishlist_item_id || item.item_id || ''
        });
      },
      handleCartClick: function handleCartClick(product) {
        var data = this.createProductObj(product);

        if (!data.product_id) {
          return;
        }

        window.productDataJSON = {
          data: data
        };

        if (data.product_type === 'configurable') {
          this.plpProductInfo = data;
          this.$nextTick(function () {
            busEvent.$emit('selectSpecShowEvent', 'addToCart');
          });
          return;
        }

        this.addSimpleProductToCart(data);
      },
      createProductObj: function createProductObj(product) {
        var productType = product.product_type || product.type || (Array.isArray(product.configattr) && product.configattr.length ? 'configurable' : 'simple');
        var productId = product.product_id || product.id || product.item_id;
        var simpleStatus = typeof product.status === 'boolean' ? product.status : product.status === 1 || product.status === '1';
        var simpleMaxSaleQty = product.max_sale_qty || product.max_sale_qty === 0 ? product.max_sale_qty : 0;
        var defaultImages = [product.image || product.imgurl || product.product_image].filter(Boolean);
        var base = Object.assign({}, product, {
          product_id: productId,
          product_type: productType,
          status: simpleStatus,
          name: product.name || product.title || '',
          short_description: product.short_description || product.desc || '',
          price: product.block && product.block.price || product.price || product.final_price || 0,
          price_label: product.block && product.block.price_label || product.price_label || product.final_price_label || '',
          origin_price_label: product.origin_price_label || product.max_price_label || '',
          level_price: product.level_price || {},
          defaultImages: defaultImages,
          images: productType === 'configurable' ? new Map() : defaultImages,
          spec: product.spec || [],
          usps: product.usps || [],
          block: product.block && product.block.block || product.block,
          is_in_wishlist: product.is_in_wishlist ? 1 : 0,
          wishlist_item_id: product.wishlist_item_id || product.item_id || 0,
          attachment: product.attachment || { option: [] },
          xp_product: Number(product.xp_product || 0),
          pickUp: product.pickUp || product.pick_up,
          url_link: product.url_link || product.product_url,
          max_sale_qty: simpleMaxSaleQty
        });

        if (productType === 'configurable') {
          base.configproduct = product.configproduct || {};
          base.configattr = product.configattr || [];
          base.level_price = this.getConfigLevelPrice(product);
        } else {
          base.configproduct = product.configproduct || [];
          base.configattr = product.configattr || [];
        }

        return base;
      },
      getConfigLevelPrice: function getConfigLevelPrice(data) {
        var attrs = data.configattr || [];
        var products = data.configproduct || {};
        var productId = 0;

        if (attrs.length === 1) {
          productId = attrs[0].options[0] && attrs[0].options[0].product_ids[0];
        } else if (attrs.length > 1) {
          var firstIds = new Set(attrs[0].options[0] && attrs[0].options[0].product_ids || []);
          var secondIds = attrs[1].options[0] && attrs[1].options[0].product_ids || [];
          productId = secondIds.filter(function (id) {
            return firstIds.has(id);
          })[0];
        }

        return productId && products['key_' + productId] ? products['key_' + productId].level_price : {};
      },
      addSimpleProductToCart: function addSimpleProductToCart(data) {
        var tmpArr = [];
        tmpArr.id = data.product_id;
        tmpArr.qty = 1;

        addToCartApi({
          data: window.serialize(tmpArr)
        }).then(function () {
          busEvent.$emit('modalSuccess', 'Added to cart successfully');
        });
      },
      toggleWishlist: function toggleWishlist(item) {
        var _this2 = this;

        if (item.wishlistBusy) {
          return false;
        }
        if (!appStorage.get('token')) {
          return Util.redirect(window.commonDataJSON && window.commonDataJSON.login_url || '/customer/account/login');
        }

        var productId = item.product_id || item.id || '';
        if (!productId) {
          return false;
        }

        item.wishlistBusy = true;

        if (item.is_in_wishlist && !item.wishlist_item_id) {
          item.wishlistBusy = false;
          return false;
        }

        if (item.is_in_wishlist) {
          return deleteWishlistApi({
            item_id: item.wishlist_item_id
          }).then(function () {
            _this2.setWishlistState(item, false);
            item.wishlistBusy = false;
          }, function () {
            item.wishlistBusy = false;
          });
        }

        return addToWishlistApi({
          product_id: productId
        }).then(function (resData) {
          _this2.setWishlistState(item, true, _this2.resolveWishlistItemId(resData, item));
          item.wishlistBusy = false;
        }, function () {
          item.wishlistBusy = false;
        });
      },
      setWishlistState: function setWishlistState(item, isWishlisted) {
        var wishlistItemId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        item.is_in_wishlist = isWishlisted ? 1 : 0;
        item.wishlist_item_id = wishlistItemId;
      },
      getProductImage: function getProductImage(item) {
        return item.image || item.imgurl || item.product_image || '';
      },
      getProductTitle: function getProductTitle(item) {
        return item.name || item.title || item.product_name || '';
      },
      getProductUrl: function getProductUrl(item) {
        return item.url || item.url_link || item.product_url || 'javascript:void(0);';
      },
      resolveWishlistItemId: function resolveWishlistItemId(resData, item) {
        var data = resData && (resData.data || resData);
        return data && (data.wishlist_item_id || data.wishlistItemId || data.item_id || data.id) || item.wishlist_item_id;
      },
      startCountdownTimer: function startCountdownTimer() {
        var _this3 = this;

        this.stopCountdownTimer();
        this.countdownTimer = setInterval(function () {
          _this3.refreshCountdowns();
        }, 1000);
      },
      stopCountdownTimer: function stopCountdownTimer() {
        if (this.countdownTimer) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      },
      refreshCountdowns: function refreshCountdowns() {
        var _this4 = this;

        this.products.forEach(function (item) {
          item.countdown = _this4.getCountdownParts(item.countdownEnd);
        });
      },
      formatPrice: function formatPrice(price) {
        return String(price || '').replace(/<[^>]+>/g, '').replace(/^[^\d]+/, '').trim();
      },
      parsePriceNumber: function parsePriceNumber(price) {
        var value = String(price || '').replace(/<[^>]+>/g, '').replace(/[^\d.]/g, '');
        return Number(value) || 0;
      },
      getCurrency: function getCurrency(priceLabel) {
        var text = String(priceLabel || '').replace(/<[^>]+>/g, '').trim();
        var match = text.match(/^[^\d]+/);
        return match ? match[0].trim() : '₦';
      },
      getCountdownEnd: function getCountdownEnd(endDate) {
        var numericEndDate = Number(endDate);
        if (numericEndDate) {
          return numericEndDate > 9999999999 ? numericEndDate : numericEndDate * 1000;
        }
        return endDate ? new Date(String(endDate).replace(/-/g, '/')).getTime() : 0;
      },
      getCountdownParts: function getCountdownParts(endDate) {
        var endTime = this.getCountdownEnd(endDate);
        var diff = Math.max(0, endTime - Date.now());
        var seconds = Math.floor(diff / 1000);
        var hours = Math.min(99, Math.floor(seconds / 3600));
        var minutes = Math.floor(seconds % 3600 / 60);
        var remainSeconds = seconds % 60;

        return [hours, minutes, remainSeconds].map(function (item) {
          return String(item).padStart(2, '0');
        });
      },
      handleGA: function handleGA(data) {
        new GAReport().productClick({
          eventAction: 'HOME_PRODUCT_CLICK_' + (this.getProductTitle(data) || '').toUpperCase(),
          eventCategory: 'HOME_PRODUCT_CLICK_#VERSION#',
          productList: [new GAReport().productItem(data)],
          location: 'HOME_FLASH_SALE'
        });
      }
    }
  };
});
